import React from 'react';
import Icon from '../elements/icons/Icon';
import eventHumanFriendlyDate from '../../misc/eventHumanFriendlyDate';
import Link from '../elements/Link';

export default class EventListItem extends React.Component {
    render() {
        let {event} = this.props,
            icon;

        if (event.joined) {
            icon = <Icon src="img/checkmark@3x.png" size={24}/>;
        } else if (event.unregistered) {
            icon = <Icon src="img/ic_cancel@3x.png" size={24} color="red" />;
        } else if (event.allow_join_from_parent) {
            icon = <Icon src="img/next.png" size={16} />;
        }

        // console.log(event);

        return (
            <Link className="EventListItem has-icon-right" href={this.props.href || '/events/' + event.id}>
                <Icon src={event.icon_url} size={80} />
                <div>
                    <p>
                        <strong>{event.name}</strong>
                    </p>
                    <p className="text-upper">{eventHumanFriendlyDate(event, event.start_utc, event.end_utc)}</p>
                    <p className="text-upper">{_.compact([event.location_name, event.location_city]).join(', ')}</p>
                </div>
                {icon}
            </Link>
        );
    }
}
